import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-print",
  "use": "icon-print-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-print\"><path d=\"M928 288H96v384h160v224h512V672h160zM704 832H320V544h384zm160-224h-96V480H256v128h-96V352h704zM320 192h384v64h64V128H256v128h64v-64z\" /><path d=\"M384 608h256v64H384zm0 96h256v64H384zm384-288a32 32 0 1064 0 32 32 0 10-64 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol